'use client';

import { usePathname } from 'next/navigation';
import { PageContentContainer } from './PageContentContainer';

export function SiteFrame({ children, header, footer }: { children: React.ReactNode; header: React.ReactNode; footer: React.ReactNode }) {
  const pathname = usePathname();
  const isVisitorRoom = pathname === '/' || pathname === '/homepage-preview';
  // Keep the existing authentication sheet mounted; its content renders in a portal.
  if (isVisitorRoom) return <><div className="hidden">{header}</div>{children}</>;
  return <div className="min-h-[100dvh] md:h-[100dvh] md:grid md:grid-rows-[auto_1fr_auto]">{header}<PageContentContainer showBackground={false}>{children}</PageContentContainer>{footer}</div>;
}
